"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearItems = exports.clearItem = exports.clearItemAvailability = exports.itemsSlice = exports.itemsInitialState = void 0;
const tslib_1 = require("tslib");
const index_1 = require("./../../actions/marketplace/getItemById/index");
const index_2 = require("../../actions/marketplace/getItemsByOwner/index");
const index_3 = require("../../actions/items/getItemById/index");
const index_4 = require("../../actions/store/getItemById/index");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const index_5 = require("../../actions/items/getItems/index");
const getAllItemsAvailability_1 = require("../../actions/saas/items/getAllItemsAvailability");
const createItem_1 = require("../../actions/saas/items/createItem");
const updateItem_1 = require("../../actions/saas/items/updateItem");
exports.itemsInitialState = {
    item: {
        error: false,
        loading: false,
        data: {},
    },
    items: {
        data: [],
        loading: false,
        availability: {
            data: [],
            loading: false,
        },
    },
    categories: {
        loading: false,
        data: [],
        raw: [],
    },
};
const combineExtraReducers = (builder) => {
    (0, index_5.getItemsExtraReducers)(builder);
    (0, index_3.getItemByIdExtraReducers)(builder);
    (0, index_2.getItemsByOwnerExtraReducers)(builder);
    (0, index_4.getStoreItemByIdExtraReducers)(builder);
    (0, index_1.getMarketItemByIdExtraReducers)(builder);
    (0, getAllItemsAvailability_1.getAllItemAvailabilityExtraReducers)(builder);
    (0, updateItem_1.updateItemExtraReducers)(builder);
    (0, createItem_1.createItemExtraReducers)(builder);
};
exports.itemsSlice = toolkitRaw.createSlice({
    name: 'items',
    initialState: exports.itemsInitialState,
    reducers: {
        clearItemAvailability: (state) => {
            state.items.availability.data = [];
        },
        clearItem: (state) => {
            state.item.data = {};
        },
        clearItems: (state) => {
            state.items.data = [];
        },
    },
    extraReducers: (builder) => {
        return combineExtraReducers(builder);
    },
});
_a = exports.itemsSlice.actions, exports.clearItemAvailability = _a.clearItemAvailability, exports.clearItem = _a.clearItem, exports.clearItems = _a.clearItems;
exports.default = exports.itemsSlice.reducer;
//# sourceMappingURL=index.js.map